import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { platform } from '../../platform/platform';
import { PLATFORM } from '../app.constants';

export class HttpService {

  private _cookieService: CookieService;
  private _httpClient: HttpClient;
  private _router: Router;
  private withCredentials: boolean;

  get isDesktop() {
    return platform.name === PLATFORM.DESKTOP;
  }

  constructor() {
    this.withCredentials = environment.withCredentials;
  }

  setCookieService(_cookieService: CookieService) {
    this._cookieService = _cookieService;
  }

  setHttpClient(_httpClient: HttpClient) {
    this._httpClient = _httpClient;
  }

  setRouter(_router: Router) {
    this._router = _router;
  }

  private getApiBaseUrl(): string {
    const apiBaseUrl = environment.PROTECTED_URIS.VISOL_API;
    return apiBaseUrl.replace(/\/?$/, "/");
  }

  getEndpoint(group: string, ...argArray: string[]): string {
    const encodedArgs = argArray.map(encodeURIComponent);
    const endpoint = this.getApiBaseUrl() + group + '/' + encodedArgs.join('/');
    return endpoint;
  }

  getReportTemplateBuilderEndpoint(params: string[], query: string): string {
    let endpoint = environment.reportTemplateBuilderUrl;
    if (params) {
      params.forEach((param, i) => {
        endpoint += param;
        if (params.length - 1 !== i) {
          endpoint += '/';
        }
      });
    }
    return endpoint + query;
  }

  getWithCredentialsOption(): boolean {
    return this.withCredentials;
  }

}
